import React, { useEffect, useState } from 'react';
import { CheckIcon, AlertTriangleIcon } from 'lucide-react';
const CART_URL = 'https://fbwqku-s9.myshopify.com/cart/52013268271396:1';
const features = ['Curso completo de Tabletas Aromáticas', 'Videos paso a paso', 'Lista de proveedores confiables', 'Fórmulas exactas y recetas probadas', 'Todos los bonos incluidos', 'Actualizaciones gratuitas de por vida', 'Soporte prioritario 24/7'];
function UrgencyCounter() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 1,
    minutes: 47,
    seconds: 33
  });
  useEffect(() => {
    const target = new Date();
    target.setHours(target.getHours() + 1);
    target.setMinutes(target.getMinutes() + 47);
    target.setSeconds(target.getSeconds() + 33);
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = target.getTime() - now;
      if (distance <= 0) {
        clearInterval(timer);
        setTimeLeft({
          hours: 0,
          minutes: 0,
          seconds: 0
        });
        return;
      }
      setTimeLeft({
        hours: Math.floor(distance / (1000 * 60 * 60)),
        minutes: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
        seconds: Math.floor(distance % (1000 * 60) / 1000)
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => String(n).padStart(2, '0');
  return <div className="bg-gradient-to-r from-rose-50 to-pink-50 border border-rose-200 rounded-2xl p-4 mb-6" data-id="element-192">
      <div className="flex items-center justify-center gap-2 mb-3" data-id="element-193">
        <AlertTriangleIcon className="w-4 h-4 text-rose-500 animate-pulse" aria-hidden="true" data-id="element-194" />
        <p className="text-sm font-bold text-rose-600 uppercase tracking-wide" data-id="element-195">
          ¡Solo quedan 3 cupos disponibles!
        </p>
        <AlertTriangleIcon className="w-4 h-4 text-rose-500 animate-pulse" aria-hidden="true" data-id="element-196" />
      </div>

      {/* Cupos visuales */}
      <div className="flex items-center justify-center gap-2 mb-4" data-id="element-197">
        {[...Array(10)].map((_, i) => <div key={i} className={`w-6 h-6 rounded-full border-2 ${i < 7 ? 'bg-rose-400 border-rose-500' : 'bg-white border-[#FF4DB8]'}`} title={i < 7 ? 'Ocupado' : 'Disponible'} data-id="element-198" />)}
      </div>
      <p className="text-xs text-center text-[#6B6B6B] mb-3" data-id="element-199">
        7 de 10 cupos tomados
      </p>

      {/* Countdown */}
      <div className="flex items-center justify-center gap-2" role="timer" aria-live="polite" data-id="element-200">
        <div className="flex flex-col items-center bg-white rounded-xl px-3 py-2 shadow-sm border border-pink-100 min-w-[52px]" data-id="element-201">
          <span className="text-xl font-extrabold text-[#FF4DB8] leading-none" data-id="element-202">
            {pad(timeLeft.hours)}
          </span>
          <span className="text-xs text-[#6B6B6B] font-medium mt-0.5" data-id="element-203">hs</span>
        </div>
        <span className="text-lg font-bold text-[#FF4DB8]" data-id="element-204">:</span>
        <div className="flex flex-col items-center bg-white rounded-xl px-3 py-2 shadow-sm border border-pink-100 min-w-[52px]" data-id="element-205">
          <span className="text-xl font-extrabold text-[#FF4DB8] leading-none" data-id="element-206">
            {pad(timeLeft.minutes)}
          </span>
          <span className="text-xs text-[#6B6B6B] font-medium mt-0.5" data-id="element-207">min</span>
        </div>
        <span className="text-lg font-bold text-[#FF4DB8]" data-id="element-208">:</span>
        <div className="flex flex-col items-center bg-white rounded-xl px-3 py-2 shadow-sm border border-pink-100 min-w-[52px]" data-id="element-209">
          <span className="text-xl font-extrabold text-[#FF4DB8] leading-none" data-id="element-210">
            {pad(timeLeft.seconds)}
          </span>
          <span className="text-xs text-[#6B6B6B] font-medium mt-0.5" data-id="element-211">seg</span>
        </div>
      </div>
      <p className="text-xs text-center text-rose-500 font-semibold mt-2" data-id="element-212">
        El precio especial vence al terminar el contador
      </p>
    </div>;
}
export function NewPricingSection() {
  return <section className="bg-gradient-to-b from-[#F8F8FA] to-white py-16 md:py-24 px-4" data-id="element-213">
      <div className="container mx-auto max-w-lg" data-id="element-214">
        <div className="text-center mb-12" data-id="element-215">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-216">
            Inversión única
          </h2>
          <p className="text-lg text-[#6B6B6B]" data-id="element-217">
            Acceso de por vida sin pagos recurrentes
          </p>
        </div>

        <div className="backdrop-blur-sm bg-white/90 rounded-3xl border-2 border-[#FF4DB8]/30 shadow-xl shadow-pink-500/20 p-8 md:p-10 animate-soft-glow" data-id="element-218">
          <UrgencyCounter data-id="element-219" />

          <div className="text-center mb-8" data-id="element-220">
            <div className="flex items-baseline justify-center gap-2 mb-2" data-id="element-221">
              <span className="text-2xl font-bold text-[#6B6B6B]" data-id="element-222">$</span>
              <span className="text-6xl md:text-7xl font-extrabold bg-gradient-to-r from-[#FF4DB8] to-[#FF6EC7] bg-clip-text text-transparent" data-id="element-223">
                18,999
              </span>
            </div>
            <p className="text-[#6B6B6B] font-medium" data-id="element-224">ARS - Pago único</p>
            <p className="text-sm text-gray-500 mt-2" data-id="element-225">
              Con la venta de tus primeras 3-4 tabletas recuperás tu inversión
            </p>
          </div>

          <div className="space-y-4 mb-8" data-id="element-226">
            {features.map((feature, index) => <div key={index} className="flex items-start gap-3" data-id="element-227">
                <div className="w-6 h-6 bg-gradient-to-br from-[#FF4DB8] to-[#FF6EC7] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-228">
                  <CheckIcon className="w-4 h-4 text-white" aria-hidden="true" data-id="element-229" />
                </div>
                <span className="text-gray-900 font-medium" data-id="element-230">{feature}</span>
              </div>)}
          </div>

          <a href={CART_URL} className="block w-full text-center px-8 py-5 bg-gradient-to-r from-[#FF4DB8] to-[#FF6EC7] hover:from-[#FF6EC7] hover:to-[#FF4DB8] text-white font-bold text-lg rounded-2xl shadow-lg shadow-pink-500/30 transition-all duration-300 hover:shadow-xl hover:shadow-pink-500/40 hover:scale-105" data-id="element-231">
            Acceder ahora — últimos 3 cupos
          </a>

          <p className="text-center text-sm text-[#6B6B6B] mt-6" data-id="element-232">
            Garantía de 72 horas • Pago seguro
          </p>
        </div>
      </div>
    </section>;
}